type RedirectLocation = Pick<
  Location,
  'hostname' | 'pathname' | 'search' | 'hash'
>;

/**
 * URL on the Castor host for a page opened on one of the project's Firebase
 * default hostnames (`<project>.web.app`, `<project>.firebaseapp.com`);
 * `undefined` everywhere else, including preview channels and localhost.
 */
export const getFirebaseDefaultHostRedirect = (
  location: RedirectLocation,
  firebaseProjectId: string,
  castorHost: string | undefined
): string | undefined => {
  const defaultHosts = [
    `${firebaseProjectId}.web.app`,
    `${firebaseProjectId}.firebaseapp.com`,
  ];

  if (
    !castorHost ||
    defaultHosts.includes(castorHost) ||
    !defaultHosts.includes(location.hostname)
  ) {
    return undefined;
  }

  return `https://${castorHost}${location.pathname}${location.search}${location.hash}`;
};
